import { Reducer } from 'redux';
import { didNotReduce } from 'utils/redux/utils';
import { Action } from 'store/store';
import { WidgetActionType } from '../actions';
import { algorithmParametersSharedStateReducer } from './algoParameters/reducer';
import { initialAlgorithmParametersSharedState } from './algoParameters/AlgorithmParametersSharedState';
import { WidgetSharedStateAction, WidgetSharedStatePayload } from './actions';
import {
    WidgetSharedState,
    initialWidgetSharedState,
    WidgetSharedStateSection,
} from './WidgetsSharedState';

const sectionStateReducerMap = {
    [WidgetSharedStateSection.ALGORITHM_PARAMETERS]:
        algorithmParametersSharedStateReducer,
};

const initialSectionStateMap = {
    [WidgetSharedStateSection.ALGORITHM_PARAMETERS]:
        initialAlgorithmParametersSharedState,
};

export const widgetSharedStateReducer: Reducer<
    WidgetSharedState,
    WidgetSharedStateAction
> = (
    state: WidgetSharedState = initialWidgetSharedState,
    action: Action<string, WidgetSharedStatePayload>
) => {
    if (!action.payload) {
        return state;
    }

    const typedAction = action as WidgetSharedStateAction;

    switch (typedAction.type) {
        case WidgetActionType.WIDGET_CLEANUP_SHARED_STATE:
            return Object.keys(state)
                .filter((section) =>
                    typedAction.payload!.preservedSections.includes(
                        section as WidgetSharedStateSection
                    )
                )
                .reduce(
                    (result, section) => ({
                        ...result,
                        [section]: state[section as WidgetSharedStateSection],
                    }),
                    {}
                );
        case WidgetActionType.WIDGET_SET_SHARED_STATE: {
            const section = typedAction.payload!.sharedSection;

            const sectionState =
                state[section] || initialSectionStateMap[section];
            const sectionStateReducer = sectionStateReducerMap[section];

            const nextState = sectionStateReducer(
                sectionState,
                typedAction.payload!.sharedSectionAction
            );

            return didNotReduce(sectionState, nextState)
                ? state
                : {
                      ...state,
                      [typedAction.payload!.sharedSection]: nextState,
                  };
        }
    }

    return state;
};
